// Global cart drawer loading state
window.cartDrawerState = {
    isLoaded: false,
    pendingClick: null
};

// Immediately prevent cart icon default behavior and queue clicks
(function () {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
        cartLink.addEventListener('click', function (event) {
            event.preventDefault();

            // If cart drawer is loaded, let it handle the click
            if (window.cartDrawerState.isLoaded) {
                return; // The CartDrawer class will handle this
            }

            // Store the pending click to process later
            window.cartDrawerState.pendingClick = {
                target: this,
                timestamp: Date.now()
            };

            // Add visual feedback that something is happening
            this.style.opacity = '0.7';
            setTimeout(() => {
                if (this.style.opacity === '0.7') {
                    this.style.opacity = '';
                }
            }, 2000);
        });
    }
})();

class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();

        // Mark cart drawer as loaded and process any pending clicks
        window.cartDrawerState.isLoaded = true;
        this.processPendingClick();
    }

    processPendingClick() {
        const pendingClick = window.cartDrawerState.pendingClick;
        if (pendingClick) {
            // Reset visual feedback
            if (pendingClick.target.style.opacity === '0.7') {
                pendingClick.target.style.opacity = '';
            }

            // Process the pending click by opening the drawer
            this.open(pendingClick.target);

            // Clear the pending click
            window.cartDrawerState.pendingClick = null;
        }
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink) return;

        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');

        // Add a new click listener that only handles clicks when drawer is loaded
        cartLink.addEventListener('click', (event) => {
            // Only handle if drawer is loaded (the global handler will manage unloaded state)
            if (window.cartDrawerState.isLoaded) {
                event.preventDefault();
                this.open(cartLink);
            }
        });

        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                if (window.cartDrawerState.isLoaded) {
                    this.open(cartLink);
                }
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });

        this.addEventListener(
            'transitionend',
            () => {
                const containerToTrapFocusOn = this.classList.contains('is-empty')
                    ? this.querySelector('.drawer__inner-empty')
                    : document.getElementById('CartDrawer');
                const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );

        document.body.classList.add('overflow-hidden');

        // Pre-load the size modal when cart drawer opens
        this.preloadSizeModal();
    }

    preloadSizeModal() {
        // Pre-load the size modal images and content when cart drawer opens
        if (window.SilonSizeModal && typeof window.SilonSizeModal.preload === 'function') {
            window.SilonSizeModal.preload();
        }
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');

        if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }

        cartDrawerNote.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });

        cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') &&
            this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);

            if (!sectionElement) return;
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer',
            },
            {
                id: 'cart-icon-bubble',
            },
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* —— GLOBAL delegated handler for "Farbe & Grösse Anpassen" buttons —— */
(function initEditCartLineButtons() {
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.edit-cart-line-btn');
        if (!btn) return;
        e.preventDefault();
        const collection = (btn.dataset.collection || '').toLowerCase();
        const lineKey = btn.dataset.lineKey;
        if (!lineKey) return console.error('[editCartLine] Missing line key');

        let colors, sizes, mapping;
        switch (collection) {
            case 'silon-puresilk-kissenbezug':
                {
                    if (window.NEW_PILLOWCASE && window.NEW_PILLOWCASE.options && window.NEW_PILLOWCASE.variants) {
                        const farbeOption = window.NEW_PILLOWCASE.options.find(opt => opt.name === 'Farbe' || opt.name === 'Color');
                        const groesseOption = window.NEW_PILLOWCASE.options.find(opt => opt.name === 'Grösse' || opt.name === 'Size');
                        const farbeIndex = window.NEW_PILLOWCASE.options.findIndex(opt => opt.name === 'Farbe' || opt.name === 'Color');
                        const groesseIndex = window.NEW_PILLOWCASE.options.findIndex(opt => opt.name === 'Grösse' || opt.name === 'Size');

                        colors = farbeOption ? farbeOption.values.map(val => {
                            // Find an image for this color if possible
                            const associatedVariant = window.NEW_PILLOWCASE.variants.find(v => v.options[farbeIndex] === val && v.image);
                            return {
                                key: val,
                                name: val,
                                imageURL: associatedVariant ? associatedVariant.image : ''
                            };
                        }) : [];

                        sizes = groesseOption ? groesseOption.values.map(val => ({
                            key: val,
                            name: val,
                            // Use typical dimensions for known sizes or leave empty
                            dimensions: (function (v) {
                                switch (v) {
                                    case 'Classic': return '40×60';
                                    case 'Comfort': return '40×80';
                                    case 'Comfort+': return '50×70';
                                    case 'Square': return '65×65';
                                    case 'Royal Square': return '80×80';
                                    case 'King/Queen': return '65×100';
                                    default: return '';
                                }
                            })(val)
                        })) : [];

                        mapping = window.NEW_PILLOWCASE.variants.map(variant => ({
                            colorKey: farbeIndex >= 0 ? variant.options[farbeIndex] : null,
                            sizeKey: groesseIndex >= 0 ? variant.options[groesseIndex] : null,
                            variationId: variant.id.toString()
                        }));
                    } else {
                        colors = [];
                        sizes = [];
                        mapping = [];
                        console.warn('[editCartLine] window.NEW_PILLOWCASE not found');
                    }
                    break;
                }
            case 'silon-puresilk-schlafmaske':
                {
                    if (window.NEW_SLEEPMASK && window.NEW_SLEEPMASK.options && window.NEW_SLEEPMASK.variants) {
                        const farbeOption = window.NEW_SLEEPMASK.options.find(opt => opt.name === 'Farbe' || opt.name === 'Color');
                        const farbeIndex = window.NEW_SLEEPMASK.options.findIndex(opt => opt.name === 'Farbe' || opt.name === 'Color');

                        colors = farbeOption ? farbeOption.values.map(val => {
                            // Find an image for this color if possible
                            const associatedVariant = window.NEW_SLEEPMASK.variants.find(v => v.options[farbeIndex] === val && v.image);
                            return {
                                key: val,
                                name: val,
                                imageURL: associatedVariant ? associatedVariant.image : ''
                            };
                        }) : [];

                        sizes = [];

                        mapping = window.NEW_SLEEPMASK.variants.map(variant => ({
                            colorKey: farbeIndex >= 0 ? variant.options[farbeIndex] : null,
                            sizeKey: null,
                            variationId: variant.id.toString()
                        }));
                    } else {
                        colors = [];
                        sizes = [];
                        mapping = [];
                        console.warn('[editCartLine] window.NEW_SLEEPMASK not found');
                    }
                    break;
                }
            case 'puresilk-kissenbezuge':
                {
                    colors = (window.COLORS_BY_COLLECTION && window.COLORS_BY_COLLECTION[collection]) || [];

                    sizes = [
                        {
                            key: "classic",
                            name: "Classic",
                            dimensions: "40×60"
                        },
                        {
                            key: "comfort",
                            name: "Comfort",
                            dimensions: "40×80"
                        },
                        {
                            key: "comfortplus",
                            name: "Comfort+",
                            dimensions: "50×70"
                        },
                        {
                            key: "square",
                            name: "Square",
                            dimensions: "65×65"
                        },
                        {
                            key: "royal-square",
                            name: "Royal Square",
                            dimensions: "80×80"
                        },
                        {
                            key: "king/queen",
                            name: "King/Queen",
                            dimensions: "65×100"
                        }
                    ]

                    mapping = [
                        {
                            colorKey: "white",
                            sizeKey: "classic",
                            variationId: "51567186903376"
                        },
                        {
                            colorKey: "white",
                            sizeKey: "comfort",
                            variationId: "51567186936144"
                        },
                        {
                            colorKey: "white",
                            sizeKey: "comfortplus",
                            variationId: "51567186870608"
                        },
                        {
                            colorKey: "white",
                            sizeKey: "square",
                            variationId: "51567186968912"
                        },
                        {
                            colorKey: "white",
                            sizeKey: "royal-square",
                            variationId: "51567187001680"
                        },
                        {
                            colorKey: "white",
                            sizeKey: "king/queen",
                            variationId: "51567187034448"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "classic",
                            variationId: "49810223235408"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "comfort",
                            variationId: "49810223300944"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "comfortplus",
                            variationId: "49810223268176"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "square",
                            variationId: "51292503048528"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "royal-square",
                            variationId: "51292503081296"
                        },
                        {
                            colorKey: "red",
                            sizeKey: "king/queen",
                            variationId: "51292503114064"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "classic",
                            variationId: "49810213241168"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "comfort",
                            variationId: "49810213306704"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "comfortplus",
                            variationId: "49810213273936"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "square",
                            variationId: "51292491350352"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "royal-square",
                            variationId: "51292491383120"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: "king/queen",
                            variationId: "51292491415888"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "classic",
                            variationId: "49810218615120"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "comfort",
                            variationId: "49810218680656"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "comfortplus",
                            variationId: "49810218647888"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "square",
                            variationId: "51292503179600"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "royal-square",
                            variationId: "51292503212368"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: "king/queen",
                            variationId: "51292503245136"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "classic",
                            variationId: "51293167255888"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "comfort",
                            variationId: "51293167321424"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "comfortplus",
                            variationId: "51293167288656"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "square",
                            variationId: "51293167354192"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "royal-square",
                            variationId: "51293167386960"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: "king/queen",
                            variationId: "51293167419728"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "classic",
                            variationId: "49810228543824"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "comfort",
                            variationId: "49810228609360"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "comfortplus",
                            variationId: "49810228576592"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "square",
                            variationId: "51292502851920"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "royal-square",
                            variationId: "51292502884688"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: "king/queen",
                            variationId: "51292502917456"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "classic",
                            variationId: "49810214945104"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "comfort",
                            variationId: "49810215010640"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "comfortplus",
                            variationId: "49810214977872"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "square",
                            variationId: "51292496462160"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "royal-square",
                            variationId: "51292496494928"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: "king/queen",
                            variationId: "51292496527696"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "classic",
                            variationId: "49810182013264"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "comfort",
                            variationId: "49810182078800"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "comfortplus",
                            variationId: "49810182046032"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "square",
                            variationId: "51292503474512"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "royal-square",
                            variationId: "51292503507280"
                        },
                        {
                            colorKey: "black",
                            sizeKey: "king/queen",
                            variationId: "51292503540048"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "classic",
                            variationId: "49810225922384"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "comfort",
                            variationId: "49810225987920"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "comfortplus",
                            variationId: "49810225955152"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "square",
                            variationId: "51292502950224"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "royal-square",
                            variationId: "51292502982992"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: "king/queen",
                            variationId: "51292503015760"
                        }
                    ]
                    break;
                }
            case 'puresilk-schlafmasken':
                {
                    colors = (window.COLORS_BY_COLLECTION && window.COLORS_BY_COLLECTION[collection]) || [];
                    mapping = [
                        {
                            colorKey: "white",
                            sizeKey: null,
                            variationId: "51557867815248"
                        },
                        {
                            colorKey: "red",
                            sizeKey: null,
                            variationId: "51557999477072"
                        },
                        {
                            colorKey: "pink",
                            sizeKey: null,
                            variationId: "51557969264976"
                        },
                        {
                            colorKey: "champagne",
                            sizeKey: null,
                            variationId: "51557995348304"
                        },
                        {
                            colorKey: "blue",
                            sizeKey: null,
                            variationId: "51557993087312"
                        },
                        {
                            colorKey: "coral",
                            sizeKey: null,
                            variationId: "51557994201424"
                        },
                        {
                            colorKey: "silver",
                            sizeKey: null,
                            variationId: "51558000066896"
                        },
                        {
                            colorKey: "black",
                            sizeKey: null,
                            variationId: "51557991940432"
                        },
                        {
                            colorKey: "gold",
                            sizeKey: null,
                            variationId: "51557974507856"
                        },
                    ]
                    break;
                }
            case 'kissen':
                {
                    sizes = [
                        {
                            key: "classic",
                            name: "Classic",
                            dimensions: "40×60"
                        },
                        {
                            key: "comfort",
                            name: "Comfort",
                            dimensions: "40×80"
                        },
                        {
                            key: "comfortplus",
                            name: "Comfort+",
                            dimensions: "50×70"
                        },
                        {
                            key: "square",
                            name: "Square",
                            dimensions: "65×65"
                        },
                        {
                            key: "royal-square",
                            name: "Royal Square",
                            dimensions: "80×80"
                        },
                        {
                            key: "king/queen",
                            name: "King/Queen",
                            dimensions: "65×100"
                        }
                    ]

                    mapping = [
                        {
                            colorKey: null,
                            sizeKey: "classic",
                            variationId: "49738390307152"
                        },
                        {
                            colorKey: null,
                            sizeKey: "comfort",
                            variationId: "49738390372688"
                        },
                        {
                            colorKey: null,
                            sizeKey: "comfortplus",
                            variationId: "49738390339920"
                        },
                        {
                            colorKey: null,
                            sizeKey: "square",
                            variationId: "51336253833552"
                        },
                        {
                            colorKey: null,
                            sizeKey: "royal-square",
                            variationId: "51336253866320"
                        },
                        {
                            colorKey: null,
                            sizeKey: "king/queen",
                            variationId: "51336253899088"
                        },
                    ]
                    break;
                }
            default:
                console.warn('[editCartLine] Unsupported collection:', collection);
                alert('Diese Produktart kann derzeit nicht angepasst werden.');
                return;
        }
        if (typeof window.editCartLine === 'function') {
            window.editCartLine(lineKey, colors, sizes, mapping);
        } else {
            console.error('editCartLine function not found');
        }
    });
})();